/**
 * VivaMaison custom-events.js
 *
 * VM HIGH-VARIANT FIX (28 Tem 2026)
 * ---------------------------------
 * Shopify Liquid `product.variants` en fazla 250 varyant dondurur. 250+
 * varyantli urunlerde temanin picker'i kalan kombinasyonlari yanlislikla
 * "Unavailable" gosterir (stok dolu olsa bile).
 *
 * Bu overlay, secenek degisiminde varyanti sunucudan cozer:
 *   GET /products/<handle>?section_id=vm-variant-resolver&option_values=ID,ID,ID
 * (sections/vm-variant-resolver.liquid) ve form id / fiyat / buton durumunu
 * duzeltir. Tema kendi cozumunu yapabildiginde (ilk 250 varyant) hicbir seye
 * karismaz — yalnizca temanin "Unavailable" biraktigi durumda devreye girer.
 *
 * Geri alma: theme-globals.liquid icinde useCustomEvents = false yap.
 */
(function () {
  'use strict';

  var SECTION_ID = 'vm-variant-resolver';
  var mapCache = {};
  var debounceT = null;

  function sectionRoot(el) {
    return (el.closest && el.closest('.shopify-section')) || document;
  }

  function getForm(root) {
    return root.querySelector('form[data-product-form]');
  }

  function parseResolver(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var s = doc.querySelector('[data-vm-resolver]');
      return s ? JSON.parse(s.textContent) : null;
    } catch (e) {
      return null;
    }
  }

  function fetchResolver(handle, ids) {
    var url = '/products/' + handle + '?section_id=' + SECTION_ID +
      (ids && ids.length ? '&option_values=' + ids.join(',') : '');
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { return t ? parseResolver(t) : null; })
      .catch(function () { return null; });
  }

  function currentPicks(root) {
    var sels = root.querySelectorAll('select[name^="options["]');
    return Array.prototype.map.call(sels, function (s) {
      return { name: s.name.slice(8, -1), value: s.value };
    });
  }

  function idsFor(map, picks) {
    var ids = [];
    for (var i = 0; i < picks.length; i++) {
      var pick = picks[i];
      var opt = null;
      for (var j = 0; j < map.options.length; j++) {
        if (map.options[j].name === pick.name) { opt = map.options[j]; break; }
      }
      if (!opt) return null;
      var val = null;
      for (var k = 0; k < opt.values.length; k++) {
        if (opt.values[k].name === pick.value) { val = opt.values[k]; break; }
      }
      if (!val || val.id == null) return null;
      ids.push(val.id);
    }
    return ids.length ? ids : null;
  }

  function applyVariant(root, data) {
    var v = data && data.variant;
    if (!v || !data.exact_match) return;

    var form = getForm(root);
    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) {
        if (idInput.tagName === 'SELECT' &&
            !idInput.querySelector('option[value="' + v.id + '"]')) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title;
          idInput.appendChild(o);
        }
        idInput.value = String(v.id);
        idInput.setAttribute('data-vm-forced', String(v.id));
      }
    }

    var wrap = root.querySelector('[data-current-variant-id]');
    if (wrap) wrap.setAttribute('data-current-variant-id', String(v.id));

    root.querySelectorAll('button[data-add-to-cart]').forEach(function (btn) {
      var txt = btn.querySelector('[data-add-to-cart-text]');
      if (v.available) {
        var wasDisabled = btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true';
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        if (wasDisabled) btn.setAttribute('data-vm-enabled', '1');
        if (txt) txt.textContent = btn.getAttribute('data-lang-available') || 'Add to bag';
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.removeAttribute('data-vm-enabled');
        if (txt) txt.textContent = btn.getAttribute('data-lang-sold-out') || 'Sold out';
      }
    });

    root.querySelectorAll('[data-price]').forEach(function (el) {
      el.textContent = v.price_formatted;
    });
    root.querySelectorAll('[data-compare-price]').forEach(function (el) {
      el.textContent = v.compare_at_price_formatted || '';
    });
  }

  // 250+ varyantli urunlerde Liquid, ilk 250 disindaki renklerin varyant
  // gorseline erisemez -> swatch bos/cizgili kalir. Galeri tum medyayi DOM'a
  // bastigi icin renk adini dosya adindan eslestirip swatch'a gorsel enjekte
  // ederiz ve temanin yanlis "disabled" isaretini kaldiririz.
  function handleize(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function fixSwatches(root, map) {
    if (!map || !map.capped) return;
    root.querySelectorAll('.product__color-swatches [data-button]').forEach(function (btn) {
      var label = (btn.getAttribute('aria-label') || '').trim();
      if (!label) return;
      if (btn.classList.contains('disabled')) btn.classList.remove('disabled');
      if (btn.querySelector('img')) return;
      var h = handleize(label);
      var src = null;
      var imgs = document.querySelectorAll('img[src*="/cdn/shop/"]');
      for (var i = 0; i < imgs.length; i++) {
        var s = imgs[i].getAttribute('src') || '';
        if (s.indexOf('-' + h + '-') !== -1) { src = s; break; }
      }
      if (!src) return;
      src = src.replace(/width=\d+/, 'width=152');
      var img = document.createElement('img');
      img.src = src;
      img.alt = label;
      img.loading = 'lazy';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:inherit;';
      btn.appendChild(img);
    });
  }

  function resolve(root) {
    var picks = currentPicks(root);
    if (!picks.length) return;
    var form = getForm(root);
    var handle = form && form.getAttribute('data-product-handle');
    if (!handle) return;

    var go = function (map) {
      var ids = idsFor(map, picks);
      if (!ids) return;
      fetchResolver(handle, ids).then(function (data) {
        if (data) applyVariant(root, data);
        fixSwatches(root, map);
      });
    };

    if (mapCache[handle]) {
      go(mapCache[handle]);
    } else {
      fetchResolver(handle, null).then(function (data) {
        if (!data || !data.options) return;
        mapCache[handle] = data;
        go(data);
      });
    }
  }

  function queueResolve(root) {
    clearTimeout(debounceT);
    debounceT = setTimeout(function () { resolve(root); }, 200);
  }

  // Sayfa acilisinda swatch gorsellerini duzelt (250+ varyantli urunlerde)
  function initSwatchFix() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      var handle = form.getAttribute('data-product-handle');
      if (!handle) return;
      var root = sectionRoot(form);
      if (!root.querySelector('.product__color-swatches [data-button]')) return;
      if (mapCache[handle]) {
        fixSwatches(root, mapCache[handle]);
      } else {
        fetchResolver(handle, null).then(function (data) {
          if (!data || !data.options) return;
          mapCache[handle] = data;
          fixSwatches(root, data);
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initSwatchFix, 400);
    });
  } else {
    setTimeout(initSwatchFix, 400);
  }

  // Secenek select'leri (tema, swatch/chip tiklarini bu select'lere yansitir)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name || t.name.indexOf('options[') !== 0) return;
    queueResolve(sectionRoot(t));
  }, true);

  // Swatch/chip tiklamalari (select change tetiklenmezse guvence)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var t = e.target.closest(
      '.product__chip, .product__color-swatches [data-button], ' +
      '.product__color-swatches label, .product__color-swatches input'
    );
    if (!t) return;
    queueResolve(sectionRoot(t));
  }, true);

  // Tema, submit sirasinda id'yi kendi (eksik) cozumuyle ezerse geri yaz
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-product-form]')) return;
    var idInput = form.querySelector('[name="id"]');
    var forced = idInput && idInput.getAttribute('data-vm-forced');
    if (forced && idInput.value !== forced) idInput.value = forced;
  }, true);

  // Temanin AJAX sepeti bozuk state yuzunden ekleyemezse: butonu biz devralip
  // /cart/add.js ile ekleriz (yalnizca butonu BIZIM aktiflestirdigimiz durumda).
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('button[data-add-to-cart][data-vm-enabled]');
    if (!btn) return;
    var root = sectionRoot(btn);
    var form = getForm(root);
    var idInput = form && form.querySelector('[name="id"]');
    var forced = idInput && idInput.getAttribute('data-vm-forced');
    if (!forced) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var txt = btn.querySelector('[data-add-to-cart-text]');
    var prevText = txt ? txt.textContent : '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(forced, 10), quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      return r.json();
    }).then(function () {
      if (txt) txt.textContent = '✓';
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      setTimeout(function () {
        if (txt) txt.textContent = prevText;
      }, 2000);
    }).catch(function () {
      if (txt) txt.textContent = prevText;
      window.location.href = '/cart/add?id=' + forced + '&quantity=' + qty;
    });
  }, true);
})();
